// import React, { Component } from 'react';
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// // import Projects from '../../api/project';
// import SectionTitle from '../SectionTitle';
// import './style.css';

// // Import project images
// import maakResidence1 from '../../images/projects/aizel-warsan-1.jpg';
// import maakResidence2 from '../../images/projects/aizel-interior-2.jpg';
// import maakResidence3 from '../../images/projects/aizel-warsan-2.jpg';
// import maakResidence4 from '../../images/projects/aizel-interior-1.jpg';

// // Import South Warsan project images
// import southWarsan1 from '../../images/UpComing-Projects/PHOTO-2025-08-04-11-21-32.jpg';
// import southWarsan2 from '../../images/UpComing-Projects/PHOTO-2025-08-04-11-21-33 (1).jpg';
// import southWarsan3 from '../../images/UpComing-Projects/PHOTO-2025-08-04-11-21-33.jpg';
// import southWarsan4 from '../../images/UpComing-Projects/PHOTO-2025-08-04-11-21-34 (1).jpg';
// import southWarsan5 from '../../images/UpComing-Projects/PHOTO-2025-08-04-11-21-34.jpg';
// import southWarsan6 from '../../images/UpComing-Projects/PHOTO-2025-08-04-11-24-16.jpg';
// // Dubai South upcoming projects
// const upcomingProjects = [
//     // South Warsan Projects
//     {
//         Id: '1',
//         pImg: southWarsan1,
//         ps1img: southWarsan2,
//         psub1img1: southWarsan3,
//         psub1img2: southWarsan4,
//         title: 'Dubai South',
//         subTitle: 'Premium Residential Development',
//         description: 'A premium residential development in South Warsan featuring modern architecture and luxurious amenities.',
//         category: 'Residential',
//         location: 'South Warsan, Dubai, UAE',
//         area: '28,000 sq ft',
//         status: 'Upcoming',
//         tag: 'upcoming'
//     },
//     {
//         Id: '2',
//         pImg: southWarsan5,
//         ps1img: southWarsan6,
//         psub1img1: southWarsan1,
//         psub1img2: southWarsan2,
//         title: 'Dubai South',
//         subTitle: 'Luxury Apartment Complex',
//         description: 'Modern luxury apartment complex in South Warsan with premium amenities and contemporary design.',
//         category: 'Residential',
//         location: 'South Warsan, Dubai, UAE',
//         area: '32,000 sq ft',
//         status: 'Upcoming',
//         tag: 'upcoming'
//     },
//     {
//         Id: '3',
//         pImg: southWarsan3,
//         ps1img: southWarsan4,
//         psub1img1: southWarsan5,
//         psub1img2: southWarsan6,
//         title: 'Dubai South',
//         subTitle: 'Mixed-Use Development',
//         description: 'A mixed-use development in South Warsan featuring residential units, retail spaces, and amenities.',
//         category: 'Mixed-Use',
//         location: 'South Warsan, Dubai, UAE',
//         area: '40,000 sq ft',
//         status: 'Upcoming',
//         tag: 'upcoming'
//     },
//     // Original Projects
//     {
//         Id: '4',
//         pImg: maakResidence3,
//         ps1img: maakResidence4,
//         psub1img1: maakResidence1,
//         psub1img2: maakResidence2,
//         title: 'Dubai South',
//         subTitle: 'Luxury Residential Development',
//         description: 'A premium residential development in Dubai South featuring modern architecture and luxurious amenities.',
//         category: 'Residential',
//         location: 'Dubai South, UAE',
//         area: '25,000 sq ft',
//         status: 'Upcoming',
//         tag: 'upcoming'
//     }
// ];

// class UpcomingProjects extends Component {
//     render() {
//         var settings = {
//             dots: false,
//             arrows: true,
//             speed: 1000,
//             slidesToShow: 3,
//             slidesToScroll: 1,
//             autoplay: true,
//             responsive: [
//                 {
//                     breakpoint: 1024,
//                     settings: {
//                         slidesToShow: 2,
//                         slidesToScroll: 1,
//                         infinite: true,
//                     }
//                 },
//                 {
//                     breakpoint: 991,
//                     settings: {
//                         slidesToShow: 2,
//                         slidesToScroll: 1
//                     }
//                 },
//                 {
//                     breakpoint: 767,
//                     settings: {
//                         slidesToShow: 1,
//                         slidesToScroll: 1
//                     }
//                 },
//                 {
//                     breakpoint: 480,
//                     settings: {
//                         slidesToShow: 1,
//                         slidesToScroll: 1
//                     }
//                 }
//             ]
//         };


//         return (
//             <div className="wpo-project-area section-padding">
//                 <div className="container">
//                     <SectionTitle
//                         MainTitle={'Upcoming Projects'}
//                         subTitle={''}
//                     />
//                     <div className="row align-items-center">
//                         <div className="wpo-project-wrap project-active owl-carousel">
//                             <Slider {...settings}>
//                                 {upcomingProjects.map((project, pot) => (
//                                     <div className="wpo-project-item" key={pot}>
//                                         <div className="wpo-project-img">
//                                             <img src={project.pImg} alt="" />
//                                             <div className="left-border"></div>
//                                             <div className="right-border"></div>
//                                             <div className="upcoming-tag">Upcoming</div>
//                                         </div>
//                                         <div className="wpo-project-text">
//                                             <h2>{project.title}</h2>
//                                             <span>{project.subTitle}</span>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </Slider>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     }
// }

// export default UpcomingProjects;


































import React, { Component } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { getUpcomingProjects } from '../../api/Home';
import SectionTitle from '../SectionTitle';
import './style.css';

class UpcomingProjects extends Component {
    state = {
        upcomingData: null,
        projects: [],
        loading: true,
        error: null
    };

    componentDidMount() {
        this.fetchUpcomingProjects();
    }

    fetchUpcomingProjects = async () => {
        try {
            const data = await getUpcomingProjects();
            
            if (data && data.length > 0) {
                // Get the first active upcoming project group
                const upcomingGroup = data[0];
                
                this.setState({
                    upcomingData: upcomingGroup,
                    projects: upcomingGroup.upcomingprojects || [],
                    loading: false
                });
            } else {
                this.setState({
                    loading: false,
                    error: 'No upcoming projects found'
                });
            }
        } catch (error) {
            console.error('Error fetching upcoming projects:', error);
            this.setState({
                loading: false,
                error: 'Failed to load upcoming projects'
            });
        }
    };

    render() {
        const { upcomingData, projects, loading, error } = this.state;

        const settings = {
            dots: false,
            arrows: true,
            speed: 1000,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        if (loading) {
            return (
                <div className="wpo-project-area section-padding">
                    <div className="container">
                        <div className="text-center">
                            <p></p>
                        </div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="wpo-project-area section-padding">
                    <div className="container">
                        <div className="text-center">
                            <p>{error}</p>
                        </div>
                    </div>
                </div>
            );
        }

        if (!projects || projects.length === 0) {
            return null; // Don't render section if no projects
        }

        return (
            <div className="wpo-project-area section-padding">
                <div className="container">
                    <SectionTitle
                        MainTitle={upcomingData?.title || 'Upcoming Projects'}
                        subTitle={''}
                    />
                    <div className="row align-items-center">
                        <div className="wpo-project-wrap project-active owl-carousel">
                            <Slider {...settings}>
                                {projects.map((project, index) => (
                                    <div className="wpo-project-item" key={project.id || index}>
                                        <div className="wpo-project-img">
                                            <img 
                                                src={project.image} 
                                                alt={project.overlay_content_title}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = 'https://via.placeholder.com/400x300?text=Project+Image';
                                                }}
                                            />
                                            <div className="left-border"></div>
                                            <div className="right-border"></div>
                                            <div className="upcoming-tag">Upcoming</div>
                                        </div>
                                        <div className="wpo-project-text">
                                            <h2>{project.overlay_content_title}</h2>
                                            <span>{project.overlay_content_subtitle}</span>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UpcomingProjects;